export default "__VITE_ASSET__BNFoK4cs__"